import Repository from './Repository';

const resource = '/invitation';

export default {
	answer(id, payload) {
		return Repository.patch(`${resource}/${id}/answer`, payload);
	}
}
